import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import TitleContainerComponent from '../../components/layout/TitleContainerComponent';
import MainPageComponent from "../../components/page/MainPageComponent";
import useAlert from '../../hooks/alert/useAlert';
import useLogin from '../../hooks/useLogin';
import useLoginValidation from '../../hooks/validation/useLoginValidation';

function UserLoginView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Iniciar sesión', href: '' }
    ];

    const alertHk = useAlert();
	const navigate = useNavigate();
    const userService = useLogin();
    const loginValidations = useLoginValidation();

	const [login, setLogin] = useState({
		email: "",
		password: ""
    })


	const onSubmitForm = async (event) => {
        event.preventDefault();
        if (checkLoginInputs(login.email)) {
            let answer = await userService.doLogin(login);
		    if (answer === "SUCCESS") {
			    clearInputs();
			    navigate("../user");
		    }
		    else {
                alertHk.showWarningAlert('No se pudo iniciar sesión, por favor revisar los datos.');
		    }
        }
    };

    function checkLoginInputs(user) {
        let validation = loginValidations.isValidUser(user);
        if (validation.length > 0) {
            alertHk.showWarningAlert(validation);
            return false
        }
        return true;    
    }


	const handleInputChange = (e) => {
		setLogin({
			...login,
			[e.target.name]: e.target.value
		});
	};

	const clearInputs = () => {
		setLogin({
			email: "",
			password: ""
		});
	}

	return (
		<div>
            <MainPageComponent requireAuthentication={false} path={breadcrumbPath}>
				<CenterCenterVerticalContainer>

					<div className="d-flex flex-column flex-grow-1"
						style={{
							maxWidth: '25rem'
						}}
					>
						<TitleContainerComponent>
							<h1>Inicio de sesión</h1>
						</TitleContainerComponent>
						<Form onSubmit={onSubmitForm} className=" border rounded p-3">
							<FormGroup>
								<Label for="email">Correo</Label>
								<Input id="email" name="email" placeholder="" type="mail" required value={login.email} onChange={handleInputChange} />
							</FormGroup>
							<FormGroup>
								<Label for="password">Contraseña</Label>
								<Input id="password" name="password" placeholder="" type="password" required value={login.password} onChange={handleInputChange} />
							</FormGroup>

                            <div className="d-flex flex-column">
                                <div className="d-flex justify-content-center">
                                    <Button>Iniciar sesión</Button>
                                </div>
								
                                <div className="pt-2 d-flex justify-content-center">
									<a href={"/user/recover"} target="_self" rel="noreferrer" id="TooltipExample" >Recuperar contraseña</a>
								</div>
                                <div className="pt-2 d-flex justify-content-center">
									<a href={"/user/register"} target="_self" rel="noreferrer" id="TooltipExample" >Crear cuenta</a>
								</div>
							</div>
						</Form>
					</div>
				</CenterCenterVerticalContainer>
			</MainPageComponent>
		</div>
	);
}

export default UserLoginView;